export enum DropDownDirectionEnum {
  left = 'left',
  right = 'right',
  fullSize = 'full-size'
}

export enum DropDownVerticalDirectionEnum {
  top = 'top',
  bottom = 'bottom'
}
